import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Form,
  Card,
} from '@themesberg/react-bootstrap';
import { get, post, put } from '../../../services/back.service';
import { useSelector } from 'react-redux';
import { validPermission } from '../../../utils/functions';
import { FaCar, FaPhone, FaUser, FaIdCard, FaTools, FaTag, FaBuilding } from 'react-icons/fa';
import Select from 'react-select';

function ModifyFormOrder({
  selectOrder,
  callback,
  onOrderLoaded
}) {
  const [idOrder, setSelectOrder] = useState(selectOrder);
  const [selectService, setSelectService] = useState({});
  const [selectVehicleClass, setSelectVehicleClass] = useState({});
  const [selectOffice, setSelectOffice] = useState({});
  const [listServices, setServices] = useState([]);
  const [listVehicleClasses, setVehicleClasses] = useState([]);
  const [listOffices, setOffices] = useState([]);
  const [infoForm, setForm] = useState({
    placa: '',
    phone: '',
    applicant: '',
    id_client: '',
    service: '',
    vehicleclass: '',
    office: '',
  });
  const permissions = useSelector((state) => state.user.permissions);
  const canShowIdClient = validPermission(permissions, 'modify_client');

  useEffect(() => {
    const init = async () => {
      if (idOrder !== '0') {
        const infoOrder = await get(`/orders/${idOrder}/`);
        if (infoOrder.success) {
          const data = infoOrder.data;
          setSelectService({ value: data.service, label: data.service_name });
          setSelectVehicleClass({ value: data.vehicleclass, label: data.vehicleclass_name });
          setSelectOffice({ value: data.office, label: data.office_name });

          setForm({
            placa: data.placa || '',
            phone: data.phone || '',
            applicant: data.applicant || '',
            id_client: data.id_client || '',
            service: data.service || '',
            vehicleclass: data.vehicleclass || '',
            office: data.office || '',
          });

          if (onOrderLoaded) onOrderLoaded(data);
        }
      }
    };
    init();
  }, [idOrder]);

  useEffect(() => {
    const initForm = async () => {
      const info = await get('/schedule/info/');
      const infoServices = await get('/orders/get_available_services/');
      if (infoServices.success) {
        setServices(infoServices.data.available_services);
      }
      if (info.success) {
        setVehicleClasses(info.data.vehicleClass);
        setOffices(info.data.office);
      }
    };
    initForm();
  }, []);

  const handleForm = ({ target }) => {
    if (target.name === 'service') setSelectService(target.data);
    if (target.name === 'vehicleclass') setSelectVehicleClass(target.data);
    if (target.name === 'office') setSelectOffice(target.data);

    const value = target.value;
    setForm({ ...infoForm, [target.name]: value });
  };

  const saveForm = async (e) => {
    e.preventDefault();
    let respo,
      variant = '',
      msg = '';

    const body = {
      placa: infoForm.placa,
      phone: infoForm.phone,
      applicant: infoForm.applicant,
      id_client: infoForm.id_client,
      service: selectService.value,
      vehicleclass: selectVehicleClass.value,
      office: selectOffice.value,
    };

    let message;
    if (idOrder === '0') {
      respo = await post('/orders/create/', body);
      message = 'Orden creada correctamente';
    } else {
      respo = await put(`/orders/${idOrder}/update/`, body);
      message = 'Orden actualizada correctamente';
    }

    if (respo.success) {
      variant = 'success';
      msg = message;
      setSelectOrder(respo.data.id);
    } else {
      variant = 'danger';
      msg = respo.message;
    }

    if (callback) callback({ type: variant, message: msg });
  };

  return (
    <Fragment>
      <Card className="shadow-sm border-0">
        <Card.Header className="bg-primary text-white py-3">
          <h5 className="mb-0">
            <FaBuilding className="me-2" />
            {idOrder === '0' ? 'Crear Nueva Orden' : 'Editar Orden'}
          </h5>
        </Card.Header>
        <Card.Body>
          <Form onSubmit={(e) => saveForm(e)}>
            <div className="row g-3">
              <div className="col-12 col-md-6 col-lg-4">
                <Form.Group controlId="placa">
                  <Form.Label>
                    <FaCar className="me-2 text-muted" />
                    Placa
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="placa"
                    value={infoForm.placa}
                    className="fw-bold text-uppercase"
                    onChange={(e) => handleForm(e)}
                    maxLength={6}
                    placeholder="Ingrese la placa del vehículo"
                    required
                  />
                </Form.Group>
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <Form.Group controlId="phone">
                  <Form.Label>
                    <FaPhone className="me-2 text-muted" />
                    Teléfono
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="phone"
                    value={infoForm.phone}
                    className="fw-bold text-uppercase"
                    onChange={(e) => handleForm(e)}
                    placeholder="Teléfono de contacto"
                    required
                  />
                </Form.Group>
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <Form.Group controlId="applicant">
                  <Form.Label>
                    <FaUser className="me-2 text-muted" />
                    Solicitante
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="applicant"
                    value={infoForm.applicant}
                    className="fw-bold text-uppercase"
                    onChange={(e) => handleForm(e)}
                    placeholder="Nombre del solicitante"
                    required
                  />
                </Form.Group>
              </div>

              {canShowIdClient && (
                <div className="col-12 col-md-6 col-lg-4">
                  <Form.Group controlId="id_client">
                    <Form.Label>
                      <FaIdCard className="me-2 text-muted" />
                      NIT Cliente
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="id_client"
                      value={infoForm.id_client}
                      className="fw-bold text-uppercase"
                      onChange={(e) => handleForm(e)}
                      placeholder="Número de identificación"
                      required
                    />
                  </Form.Group>
                </div>
              )}

              <div className="col-12 col-md-6 col-lg-4">
                <Form.Group controlId="service">
                  <Form.Label>
                    <FaTools className="me-2 text-muted" />
                    Servicio
                  </Form.Label>
                  <Select
                    options={listServices}
                    value={selectService}
                    onChange={(data) => handleForm({ target: { value: data.value, name: "service", data } })}
                    placeholder="Seleccione un servicio"
                    required
                  />
                </Form.Group>
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <Form.Group controlId="vehicleclass">
                  <Form.Label>
                    <FaTag className="me-2 text-muted" />
                    Clase Vehículo
                  </Form.Label>
                  <Select
                    options={listVehicleClasses}
                    value={selectVehicleClass}
                    onChange={(data) => handleForm({ target: { value: data.value, name: "vehicleclass", data } })}
                    placeholder="Seleccione clase"
                    required
                  />
                </Form.Group>
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <Form.Group controlId="office">
                  <Form.Label>
                    <FaBuilding className="me-2 text-muted" />
                    Oficina
                  </Form.Label>
                  <Select
                    options={listOffices}
                    value={selectOffice}
                    onChange={(data) => handleForm({ target: { value: data.value, name: "office", data } })}
                    placeholder="Seleccione oficina"
                    required
                  />
                </Form.Group>
              </div>

              <div className="col-12 mt-4 text-end">
                <Button type="submit" variant="primary" size="lg" className="px-5">
                  {idOrder === '0' ? 'Crear Orden' : 'Actualizar Orden'}
                </Button>
              </div>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Fragment>
  );
}

export default ModifyFormOrder;